import controller from './left.controller';

const template = require('./left.html');

export default {
    bindings: {
        nav: '<',
        onToggle: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/navbar/left/left.component.js